// extracted by mini-css-extract-plugin
module.exports = {"bg":"VideoBackground_bg__Vyzpf","video":"VideoBackground_video__WlvEQ","overlay":"VideoBackground_overlay__8L8Xi"};